import { ca } from '@cian/analytics';

export const trackFindClick = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'button_search',
    category: 'main_page',
    label,
  });
};
